<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">BAYİ RAPORU</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Raporlar</li>
            <li class="breadcrumb-item active">Bayi Raporu</li>
        </ol>
    </div>



    <div class="data-grid">
        <p-table #dt [value]="bindData" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['projectName','customerName','serviceName','portalName','contractTypeName','contractNumber','numberOfTerminals']"
            [responsive]="true" [rowsPerPageOptions]="[5,10,25,50]" (onFilter)="filterData($event)">
            <ng-template pTemplate="caption">

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="Dışa Aktar" tooltipPosition="bottom"
                    label="Dışa Aktar"></button>

                <div class="text-center" *ngIf="loading">
                    <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-secondary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="dealerName">Bayi<p-sortIcon field="dealerName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="customerName">Müşteri<p-sortIcon field="customerName">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="projectName">Proje<p-sortIcon field="projectName">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="serviceName">Hizmet<p-sortIcon field="serviceName">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="contractTypeName">Abonelik Tipi<p-sortIcon field="ContractTypeName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="numberOfTerminals">Terminaller<p-sortIcon field="numberOfTerminals">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="serviceUnitPrice">Birim Fiyat<p-sortIcon field="serviceUnitPrice">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="totalPrice">Toplam<p-sortIcon field="totalPrice">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="currencyUnit">Para Birimi<p-sortIcon field="currencyUnit">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="commissionPrice">Birim Komisyon<p-sortIcon field="commissionPrice">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="totalCommissionPrice">Toplam Komisyon<p-sortIcon field="totalCommissionPrice">
                        </p-sortIcon>
                    <th pSortableColumn="invoiceDate">Faturalama Tarihi<p-sortIcon field="invoiceDate">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="month">Ay<p-sortIcon field="month">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="year">Yıl<p-sortIcon field="year">
                        </p-sortIcon>
                    </th>


                </tr>

                <tr>
                    <th>
                        <p-columnFilter field="dealerName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="dealers" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="dealerName" optionValue="dealerName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.dealerName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="customerName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="customers" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="customerName"
                                    optionValue="customerName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.customerName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="projectName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="projects" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="projectName"
                                    optionValue="projectName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.projectName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="serviceName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="services" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="serviceName"
                                    optionValue="serviceName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.serviceName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="contractTypeName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="contractTypes" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="contractTypeName"
                                    optionValue="contractTypeName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.contractTypeName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                    <th>
                        <p-columnFilter field="month" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="months" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="month" optionValue="month">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.month}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="year" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="years" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="year" optionValue="year">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.year}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                </tr>

            </ng-template>
            <ng-template pTemplate="body" let-report>
                <tr>
                    <td>{{report.dealerName}}</td>
                    <td>{{report.customerName}}</td>
                    <td>{{report.projectName}}</td>
                    <td>{{report.serviceName}}</td>
                    <td>{{report.contractTypeName}}</td>
                    <td>{{report.numberOfTerminals}}</td>
                    <td>{{report.serviceUnitPrice| number: '1.0'}} {{report.currencyUnit}}</td>
                    <td>{{report.totalPrice| number: '1.0'}} {{report.currencyUnit}}</td>
                    <td>{{report.currencyUnit}}</td>
                    <td>{{report.commissionPrice| number: '1.0'}} {{report.currencyUnit}}</td>
                    <td>{{report.totalCommissionPrice| number: '1.0'}} {{report.currencyUnit}}</td>
                    <td>{{report.invoiceDate | date: "d.MM.yyyy"}}</td>
                    <td>{{report.month}}</td>
                    <td>{{report.year}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <br>
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>{{calcTotalPrice() | number:'1.0'}}</th>
                    <th></th>
                    <th></th>
                    <th>{{calcTotalComPrice() | number:'1.0'}}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>